// extracted by mini-css-extract-plugin
export var button = "navigation-module--button--qBd3n";
export var menu = "navigation-module--menu--23S5E";